module.exports = __webpack_public_path__ + "img/project-32.9a96d3d4.png";